import { Expose } from "class-transformer";

interface IClientConstantCmsDto {
  id: number;
  constantValue: string;
  constantName: string;
  locale: string;
}

export class ClientConstantCmsDto implements IClientConstantCmsDto {
  @Expose()
  id!: number;

  @Expose({ name: "value" })
  constantValue!: string;

  @Expose({ name: "name" })
  constantName!: string;

  @Expose()
  locale!: string;
}
